<template>
  <div>
    <el-table :data="users" stripe style="width: 100%">
      <el-table-column prop="name" label="姓名" width="130"></el-table-column>
      <el-table-column
        prop="phone_number"
        label="手机号"
        align="center"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="email"
        label="邮箱"
        min-width="160"
      ></el-table-column>
      <!-- <el-table-column label="区域 / 城市" align="center">
        <template slot-scope="scope">
          {{ AreaTextMap[scope.row.area_id] || '-' }}<br />
          {{ CodeToText[scope.row.province] }}{{ CodeToText[scope.row.city] }}
        </template>
      </el-table-column> -->
      <el-table-column label="派工区域" align="left">
        <template slot-scope="scope">
          <el-select
            v-if="editIndex == scope.$index"
            style="width: 100%"
            size="small"
            v-model="scope.row.dispatch_area_ids"
            placeholder="请选择区域"
            clearable
            multiple
          >
            <el-option
              v-for="(value, index) in AreaTextMap"
              :key="index"
              :label="value"
              :value="parseInt(index)"
            ></el-option>
          </el-select>
          <div v-else>
            <template
              v-if="
                !scope.row.dispatch_area_ids ||
                scope.row.dispatch_area_ids.length == 0
              "
              >所有区域</template
            >
            <template v-else>
              <el-tag
                type="info"
                class="mr-5"
                size="small"
                v-for="id in scope.row.dispatch_area_ids"
                :key="id"
              >
                {{ AreaTextMap[id] }}
              </el-tag>
            </template>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="">
        <template slot-scope="scope">
          <el-button
            class="ml-10"
            type="primary"
            plain
            size="mini"
            @click="handleEdit(scope.$index)"
            >{{ editIndex == scope.$index ? '保存' : '编辑' }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  updateUserDispatchArea,
  userListByAuthCode,
} from '../../service/getData'
import { AreaTextMap } from '@/config/global'
import { CodeToText } from '@/util/area_tool'

export default {
  data() {
    return {
      users: [],
      AreaTextMap,
      CodeToText,
      editIndex: -1,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let data = {
        auth_code: '171104',
      }
      let res = await userListByAuthCode(data)
      if (res.code == 0) {
        this.users = res.data.list.filter((item) => item.status == 1)
      }
    },

    async handleEdit(index) {
      if (this.editIndex != index) {
        this.editIndex = index
        return
      }
      let user = this.users[index]
      let res = await updateUserDispatchArea({
        id: user.id,
        dispatch_area_ids: user.dispatch_area_ids,
      })

      if (res.code == 0) {
        this.editIndex = -1
        this.$message.success('保存成功！')
      }
    },
  },
}
</script>